import React from 'react';

function MainHeader() {
    return (
        <header className="tempheader">
            <a href="https://www.indiegogo.com/projects/decades-chapter-ii/x/492696#/" className="button button--white" target="_blank" rel="noreferrer">Click here to donate</a>
            <div className="furniture furniture--3"></div>
            <p className="heading-5">2002–2012–2022</p>
           <h1 className="heading-1 heading-1--temp">
               May <span className="type-correct">
                   3<span className="superscript">rd</span>
                   </span>, 2022 <span className="block-type">12:00 PM Sharp</span>
           </h1>
        </header>
     
    );
}

export default MainHeader;